import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';
import fetch from 'cross-fetch';

import introspectionResult from '../types';
import Cookies from '../utils/cookies';

declare global {
  interface Window {
    __APOLLO_STATE__: any;
    videoEvents: any;
    verseEvents: any;
  }
}

window.__APOLLO_STATE__ = window.__APOLLO_STATE__ || {};

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionResult,
});

const createApolloClient = (
  redirect,
  serverCookies = undefined,
  // eslint-disable-next-line no-unused-vars
  host = '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  userAgent = '',
  getToken,
) => {
  const ssrMode = !!serverCookies;
  let cookies;
  if (ssrMode) {
    cookies = {
      // @ts-ignore
      get: (name) => serverCookies && serverCookies[name],
    };
  } else {
    cookies = Cookies;
  }

  const windowHostname = window?.location?.hostname;
  const headers = {
    'client-referer': windowHostname || host,
  };

  // eslint-disable-next-line
  console.log('Custom headers: ', headers);

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_API_URL,
    credentials: 'same-origin',
    headers,
    fetch,
  });

  const authLink = setContext(async (_, { headers }) => {
    // get the authentication token from local storage if it exists
    let token;
    if (getToken) {
      try {
        token = await getToken();
      } catch (e) {}
    }

    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      let isUNAUTHORIZED = false;
      graphQLErrors.forEach(({ message }) => {
        if (message.includes('UNAUTHORIZED')) {
          isUNAUTHORIZED = true;
        }
      });
      if (isUNAUTHORIZED) {
        if (ssrMode) {
          cookies.clear();
          return redirect();
        }
        try {
          const oldHeaders = operation.getContext().headers;
          if (oldHeaders && oldHeaders.retried) {
            throw new Error('Anyway error');
          }
          operation.setContext({
            headers: {
              ...oldHeaders,
              // authorization: handleRefreshToken(),
              retried: 'true',
            },
          });
          return forward(operation);
        } catch (err) {
          cookies.clear();
          localStorage.clear();
          return redirect();
        }
      }
    }
    if (networkError) {
      return;
    }
  });

  const cache = ssrMode
    ? new InMemoryCache({ fragmentMatcher })
    : new InMemoryCache({ fragmentMatcher }).restore(window.__APOLLO_STATE__);

  cache.writeData({
    data: {
      hasNews: true,
    },
  });

  return new ApolloClient({
    ssrMode,
    link: errorLink.concat(authLink.concat(httpLink)),
    ssrForceFetchDelay: 1000,
    cache,
    resolvers: {},
  });
};

export default createApolloClient;
